
$('#clock').countdown('2030/10/10', function (event) {
  $('#hours').html(event.strftime('%H'));
  $('#minutes').html(event.strftime('%M'));
  $('#seconds').html(event.strftime('%S'));
});
$('[data-countdown]').each(function() {
    var $this = $(this), finalDate = $(this).data('countdown');
    $this.countdown(finalDate, function(event) {
      var $this = $(this).html(event.strftime(''
      + '<span class="timer-count heading-SB">%H</span>'
      + '<span class="timer-count heading-SB dots-span">%M</span>'
      + '<span class="timer-count heading-SB">%S</span>'));
    });
});


//Loader Js

window.addEventListener("load", function () {
	const Loader = document.querySelector(".Loader");
	Loader.classList.add("hidden");
});

//Loader Js

// Swiper One Hero Start here

var swiper = new Swiper("#Swiper1", {
  spaceBetween: 24,
  loop: true,
  autoplay: true,
  speed: 1000,
  slidesPerView: 3,
  autoplay: {
    delay: 1000,
    disableOnInteraction: false,
    stopOnLast: false,
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    575: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    },
  },
});

// // Swiper One Hero end here

// // Swiper two Hero Start here

const swiper2 = new Swiper('#auction1', {
  spaceBetween: 24,
  loop: false,
  slidesPerView: 4,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  },
  navigation: {
    nextEl: ".swiper-button-next4",
    prevEl: ".swiper-button-prev4",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    575: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    },
    1441: {
      slidesPerView: 4,
    },
  },
});

// // Swiper two Hero end here

// // Swiper two Hero Start here

const swiper15 = new Swiper('#auction2', {
  spaceBetween: 24,
  loop: false,
  slidesPerView: 4,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  },
  navigation: {
    nextEl: ".swiper-button-next5",
    prevEl: ".swiper-button-prev5",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    575: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    },
    1441: {
      slidesPerView: 4,
    },
  },
});

// // Swiper two Hero end here

// // Swiper two Hero Start here

const swiper16 = new Swiper('#auction3', {
  spaceBetween: 24,
  loop: false,
  slidesPerView: 4,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  },
  navigation: {
    nextEl: ".swiper-button-next6",
    prevEl: ".swiper-button-prev6",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    575: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    },
    1441: {
      slidesPerView: 4,
    },
  },
});

// // Swiper two Hero end here

// // Swiper two Hero Start here

const swiper17 = new Swiper('#auction4', {
  spaceBetween: 24,
  loop: false,
  slidesPerView: 4,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  },
  navigation: {
    nextEl: ".swiper-button-next7",
    prevEl: ".swiper-button-prev7",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    575: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    },
    1441: {
      slidesPerView: 4,
    },
  },
});

// // Swiper two Hero end here

// // Swiper two Hero Start here

const swiper18 = new Swiper('#auction5', {
  spaceBetween: 24,
  loop: false,
  slidesPerView: 4,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  },
  navigation: {
    nextEl: ".swiper-button-next8",
    prevEl: ".swiper-button-prev8",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    575: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    },
    1441: {
      slidesPerView: 4,
    },
  },
});

// // Swiper two Hero end here

// // Swiper two Hero Start here

const swiper19 = new Swiper('#auction6', {
  spaceBetween: 24,
  loop: false,
  slidesPerView: 4,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  },
  navigation: {
    nextEl: ".swiper-button-next9",
    prevEl: ".swiper-button-prev9",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    575: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    },
    1441: {
      slidesPerView: 4,
    },
  },
});

// // Swiper two Hero end here

// // Swiper two Hero Start here

const swiper20 = new Swiper('#auction7', {
  spaceBetween: 24,
  loop: false,
  slidesPerView: 4,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  },
  navigation: {
    nextEl: ".swiper-button-next10",
    prevEl: ".swiper-button-prev10",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    575: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    },
    1441: {
      slidesPerView: 4,
    },
  },
});

// // Swiper two Hero end here

// // Swiper two Hero Start here

const swiper21 = new Swiper('#auction8', {
  spaceBetween: 24,
  loop: false,
  slidesPerView: 4,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  },
  navigation: {
    nextEl: ".swiper-button-next11",
    prevEl: ".swiper-button-prev11",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    575: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    },
    1441: {
      slidesPerView: 4,
    },
  },
});

// // Swiper two Hero end here

// // Swiper three Hero Start here

const swiper3 = new Swiper('#swiper3', {
  spaceBetween: 24,
  loop: false,
  slidesPerView: 3,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  },
  navigation: {
    nextEl: ".swiper-button-next12",
    prevEl: ".swiper-button-prev12",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    575: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    },
  },
});

// // Swiper three Hero end here

// // Swiper four Hero Start here

var swiper4 = new Swiper("#swiper4", {
  effect: "cards",
  grabCursor: true,
  loop: true,
  autoplay: true,
  autoplay: {
    delay: 1000,
    disableOnInteraction: false,
    stopOnLast: false,
  },
});

// // Swiper four Hero end here

// // Swiper five Hero Start here

var swiper5 = new Swiper("#hero4-slide2", {
  spaceBetween: 24,
  slidesPerView: 3,
  freeMode: true,
  watchSlidesProgress: true,
});
var swiper6 = new Swiper("#hero4-slide1", {
  spaceBetween: 24,
  thumbs: {
    swiper: swiper5,
  },
});

// Swiper five Hero end here

// // Swiper Eight Hero Start here

var swiper7 = new Swiper("#hero8-slider1", {
  slidesPerView: 2,
  centeredSlides: true,
  autoplay: true,
  speed: 1000,
  loop: true,
  spaceBetween: 24,
  direction: "vertical",
  autoplay: {
    delay: 1000,
    disableOnInteraction: false,
    stopOnLast: false,
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
      centeredSlides: false,
    },
    575: {
      slidesPerView: 2,
    },
  },
});

var swiper22 = new Swiper("#hero8-slider2", {
  slidesPerView: 2,
  centeredSlides: true,
  autoplay: true,
  speed: 1000,
  loop: true,
  spaceBetween: 24,
  direction: "vertical",
  autoplay: {
    delay: 1000,
    disableOnInteraction: false,
    stopOnLast: false,
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
      centeredSlides: false,
    },
    575: {
      slidesPerView: 2,
    },
  },
});

// // Swiper Eight Hero Start here

// Select Start Here

$('select').each(function(){
  var $this = $(this), numberOfOptions = $(this).children('option').length;

  $this.addClass('select-hidden'); 
  $this.wrap('<div class="select"></div>');
  $this.after('<div class="select-styled"></div>');

  var $styledSelect = $this.next('div.select-styled');
  $styledSelect.text($this.children('option').eq(0).text());

  var $list = $('<ul />', {
      'class': 'select-options'
  }).insertAfter($styledSelect);

  for (var i = 0; i < numberOfOptions; i++) {
      $('<li />', {
          text: $this.children('option').eq(i).text(),
          rel: $this.children('option').eq(i).val()
      }).appendTo($list);
  }

  var $listItems = $list.children('li');

  $styledSelect.click(function(e) {
      e.stopPropagation();
      $('div.select-styled.active').not(this).each(function(){
          $(this).removeClass('active').next('ul.select-options').hide();
      });
      $(this).toggleClass('active').next('ul.select-options').toggle();
  });

  $listItems.click(function(e) {
      e.stopPropagation();
      $styledSelect.text($(this).text()).removeClass('active');
      $this.val($(this).attr('rel'));
      $list.hide();
      //console.log($this.val());
  });

  $(document).click(function() {
      $styledSelect.removeClass('active');
      $list.hide();
  });

});

// Select End Here

//Filter Start Here

$(document).ready(function(){
  $(".btn-1").click(function(){
      $(".filter-1").toggleClass("filter-active");
  });
  $(".btn-2").click(function(){
      $(".filter-2").toggleClass("filter-active");
  });
  $(".btn-3").click(function(){
      $(".filter-3").toggleClass("filter-active");
  });
  $(".btn-4").click(function(){
      $(".filter-4").toggleClass("filter-active");
  });
  $(".btn-5").click(function(){
      $(".filter-5").toggleClass("filter-active");
  });
  $(".btn-6").click(function(){
      $(".filter-6").toggleClass("filter-active");
  });
  $(".btn-7").click(function(){
      $(".filter-7").toggleClass("filter-active");
  });
  $(".btn-8").click(function(){
      $(".filter-8").toggleClass("filter-active");
  });
  $(".btn-9").click(function(){
      $(".filter-9").toggleClass("filter-active");
  });
  $(".clear-filter").click(function(){
      $(".filter-activity").removeClass("filter-active");
  });
});

//Filter End Here

// // Swiper six Hero Start here

var swiper8 = new Swiper("#creator-slider1", {
  slidesPerView: 5,
  loop: true,
  spaceBetween: 16,
  autoplay: {
    delay: 1000,
    disableOnInteraction: false,
    stopOnLast: false,
  },
  breakpoints: {
    0: {
      slidesPerView: 2,
      centeredSlides: false,
    },
    420: {
      slidesPerView: 3,
      centeredSlides: false,
    },
    575: {
      slidesPerView: 5,
    },
  },
});
var swiper23 = new Swiper("#creator-slider2", {
  slidesPerView: 5,
  loop: true,
  spaceBetween: 16,
  autoplay: {
    delay: 1000,
    disableOnInteraction: false,
    stopOnLast: false,
  },
  breakpoints: {
    0: {
      slidesPerView: 2,
      centeredSlides: false,
    },
    420: {
      slidesPerView: 3,
      centeredSlides: false,
    },
    575: {
      slidesPerView: 5,
    },
  },
});
var swiper24 = new Swiper("#creator-slider3", {
  slidesPerView: 5,
  loop: true,
  spaceBetween: 16,
  autoplay: {
    delay: 1000,
    disableOnInteraction: false,
    stopOnLast: false,
  },
  breakpoints: {
    0: {
      slidesPerView: 2,
      centeredSlides: false,
    },
    420: {
      slidesPerView: 3,
      centeredSlides: false,
    },
    575: {
      slidesPerView: 5,
    },
  },
});
var swiper25 = new Swiper("#creator-slider4", {
  slidesPerView: 5,
  loop: true,
  spaceBetween: 16,
  autoplay: {
    delay: 1000,
    disableOnInteraction: false,
    stopOnLast: false,
  },
  breakpoints: {
    0: {
      slidesPerView: 2,
      centeredSlides: false,
    },
    420: {
      slidesPerView: 3,
      centeredSlides: false,
    },
    575: {
      slidesPerView: 5,
    },
  },
});
var swiper26 = new Swiper("#creator-slider5", {
  slidesPerView: 5,
  loop: true,
  spaceBetween: 16,
  autoplay: {
    delay: 1000,
    disableOnInteraction: false,
    stopOnLast: false,
  },
  breakpoints: {
    0: {
      slidesPerView: 2,
      centeredSlides: false,
    },
    420: {
      slidesPerView: 3,
      centeredSlides: false,
    },
    575: {
      slidesPerView: 5,
    },
  },
});
var swiper27 = new Swiper("#creator-slider6", {
  slidesPerView: 5,
  loop: true,
  spaceBetween: 16,
  autoplay: {
    delay: 1000,
    disableOnInteraction: false,
    stopOnLast: false,
  },
  breakpoints: {
    0: {
      slidesPerView: 2,
      centeredSlides: false,
    },
    420: {
      slidesPerView: 3,
      centeredSlides: false,
    },
    575: {
      slidesPerView: 5,
    },
  },
});

// // Swiper six Hero end here


//border Start Here

$(document).ready(function(){
  $(".boxx-2").click(function(){
      $(".boxx-2").toggleClass("active-border");
      $(".boxx-3").removeClass("active-border");
      $(".boxx-4").removeClass("active-border");
  });
  $(".boxx-3").click(function(){
      $(".boxx-3").toggleClass("active-border");
      $(".boxx-2").removeClass("active-border");
      $(".boxx-4").removeClass("active-border");
  });
  $(".boxx-4").click(function(){
      $(".boxx-4").toggleClass("active-border");
      $(".boxx-3").removeClass("active-border");
      $(".boxx-2").removeClass("active-border");
  });
});

//border End Here


//Share Popup Start Here

$(document).ready(function(){
  $(".share-pop").click(function(){
      $(".share-pop-otr").toggleClass("share-pop-active");
  });
});

//Share Popup End Here

// notification drop start here

$(document).ready(function(){
  $(".bell-icon-otr").click(function(){
    $(".bell-icon-inr").toggleClass("bell-icon-inr-open");
    $(".bell-popup-otr").toggleClass("bell-popup-otr-open");
    $(".profile-popup-otr").removeClass("profile-popup-otr-open");
    $(".modal").removeClass("show");
  });
  $(".user-profile-otr").click(function(){
    $(".profile-popup-otr").toggleClass("profile-popup-otr-open");
    $(".bell-icon-inr").removeClass("bell-icon-inr-open");
    $(".bell-popup-otr").removeClass("bell-popup-otr-open");
    $(".modal").removeClass("show");
  });
  $(".menu-icon-otr").click(function(){
    $(".profile-popup-otr").removeClass("profile-popup-otr-open");
    $(".bell-icon-inr").removeClass("bell-icon-inr-open");
    $(".bell-popup-otr").removeClass("bell-popup-otr-open");
    $(".modal").removeClass("show");
  });
  $(".search-icon-otr").click(function(){
    $(".profile-popup-otr").removeClass("profile-popup-otr-open");
    $(".bell-icon-inr").removeClass("bell-icon-inr-open");
    $(".bell-popup-otr").removeClass("bell-popup-otr-open");
  });
});

// notification drop end here

//landing-page Start Here

$(document).ready(function(){
  $(".landing-menu").click(function(){
      $(".offcanvas-backdrop").removeClass("show");
      $(".offcanvas").removeClass("show");
  });
});

//landing-page End Here





// // Swiper two Hero Start here

const swiper9 = new Swiper('#live-auction1', {
  spaceBetween: 24,
  loop: false,
  slidesPerView: 4,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  },
  navigation: {
    nextEl: ".swiper-button-next1",
    prevEl: ".swiper-button-prev1",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    575: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    },
    1441: {
      slidesPerView: 4,
    },
  },
});

// // Swiper two Hero end here

// // Swiper two Hero Start here

const swiper10 = new Swiper('#live-auction2', {
  spaceBetween: 24,
  loop: false,
  slidesPerView: 4,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  },
  navigation: {
    nextEl: ".swiper-button-next2",
    prevEl: ".swiper-button-prev2",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    575: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    },
    1441: {
      slidesPerView: 4,
    },
  },
});

// // Swiper two Hero end here


// // Swiper two Hero Start here

const swiper11 = new Swiper('#live-auction3', {
  spaceBetween: 24,
  loop: false,
  slidesPerView: 4,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  },
  navigation: {
    nextEl: ".swiper-button-next3",
    prevEl: ".swiper-button-prev3",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    575: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    },
    1441: {
      slidesPerView: 4,
    },
  },
});

// // Swiper two Hero end here



// // Swiper three Hero Start here

const swiper12 = new Swiper('#popular1', {
  spaceBetween: 24,
  loop: false,
  slidesPerView: 3,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  },
  navigation: {
    nextEl: ".swiper-button-next1",
    prevEl: ".swiper-button-prev1",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    575: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    },
  },
});

// // Swiper three Hero end here

// // Swiper three Hero Start here

const swiper13 = new Swiper('#popular2', {
  spaceBetween: 24,
  loop: false,
  slidesPerView: 3,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  },
  navigation: {
    nextEl: ".swiper-button-next2",
    prevEl: ".swiper-button-prev2",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    575: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    },
  },
});

// // Swiper three Hero end here

// // Swiper three Hero Start here

const swiper14 = new Swiper('#popular3', {
  spaceBetween: 24,
  loop: false,
  slidesPerView: 3,
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  },
  navigation: {
    nextEl: ".swiper-button-next3",
    prevEl: ".swiper-button-prev3",
  },
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    575: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    },
  },
});

// // Swiper three Hero end here